import PreviewImages from '@/common/components/adjusterReport/previewImages/PreviewImages';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import LoadingPage from '@/common/pages/LoadingPage';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import RepeatCapturingModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/RepeatCapturingModal';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { useRemoveDamagedPartsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default function () {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <DamagedVehicleImagesShowEditable />
    </MainLayout>
  );
}

const DamagedVehicleImagesShowEditable = () => {
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { closeModal, open, openModal } = useModal();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const {
    data: vehicleImages,
    isPending,
    isFetching,
  } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      damaged_id: +damagedId!,
      participantRoleType: 'damaged',
    }),
  );
  const { getCurrentFileOfflineImages, deleteOfflineFileData } =
    useGetOfflineImages();
  const addDamagedPoints = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        id: id!,
        damagedId: damagedId!,
      }).ADJUSTER_VEHICLE.editablePreviewImages,
    );
  };
  const retakePhotoModal = () => {
    openModal();
  };
  const confirmRetakePhoto = async () => {
    const file = await getCurrentFileOfflineImages({ damagedId });
    if (file.hasOffline && file.offlineItem?.id) {
      deleteOfflineFileData(file.offlineItem?.id);
    }

    openModal();
    resetDamagedPoints();
    resetCameraStore();
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        id: id!,
        damagedId: damagedId!,
      }).ADJUSTER_VEHICLE.damagedPoints,
    );
  };

  const { mutateAsync: deleteImage } = useRemoveDamagedPartsQueryOptions();

  const handleDeleteDamagePointImage = (
    image_id: number,
    closeConfirmationModal?: () => void,
  ) => {
    deleteImage({
      image_id,
      id: +id!,
      type: 'damaged',
      damaged_id: +damagedId!,
      participantRoleType: 'damaged',
    }).finally(() => {
      closeConfirmationModal?.();
      queryClient.invalidateQueries({
        queryKey: getDamagedAdjusterImagesQueryOptions({
          id: +id!,
          enable: true,
          damaged_id: +damagedId!,
          participantRoleType: 'damaged',
        }).queryKey,
      });
    });
  };

  if (isPending || isFetching) {
    return <LoadingPage />;
  }
  return (
    <Box pt={24}>
      <PreviewImages
        userType="damaged"
        handleDeleteImage={handleDeleteDamagePointImage}
        addDamagePoint={addDamagedPoints}
        retakeImage={retakePhotoModal}
        images={{
          damagedImages:
            vehicleImages?.damaged_parts.map((item) => ({
              name: item.label,
              src: item.url,
              id: item.id,
              type: 'damaged',
            })) ?? [],
          vehicleImages:
            vehicleImages?.vehicle.map((item) => ({
              name: item.label,
              src: item.url,
            })) ?? [],
        }}
      />
      <RepeatCapturingModal
        closeModal={closeModal}
        repeatCapturing={confirmRetakePhoto}
        open={open}
      />
    </Box>
  );
};
